import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function DocumentIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6 2H4.8c-.442 0-.8.373-.8.833v18.334c0 .46.358.833.8.833h14.4c.442 0 .8-.373.8-.833v-12.5h-5.6c-.442 0-.8-.373-.8-.834V2zM6.398 16.166h11.2v1.667h-11.2v-1.666zM17.598 12h-11.2v1.667h11.2V12zm-6.4-2.5h-4.8V7.833h4.8V9.5zM15.2 7h4.331L15.2 2.488V7z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Document.js.map